/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AssignTrainee,
  Trainee,
} from '../models/index';
import {
    AssignTraineeFromJSON,
    AssignTraineeToJSON,
    TraineeFromJSON,
    TraineeToJSON,
} from '../models/index';

export interface TraineeManagementAssignTraineeRequest {
    assignTrainee: AssignTrainee;
}

export interface TraineeManagementListTraineesForTrainerIdRequest {
    id: string;
}

export interface TraineeManagementUnAssignTraineeRequest {
    assignTrainee: AssignTrainee;
}

/**
 * 
 */
export class TraineeManagementApi extends runtime.BaseAPI {

    /**
     */
    async traineeManagementAssignTraineeRaw(requestParameters: TraineeManagementAssignTraineeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['assignTrainee'] == null) {
            throw new runtime.RequiredError(
                'assignTrainee',
                'Required parameter "assignTrainee" was null or undefined when calling traineeManagementAssignTrainee().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/trainee-management`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AssignTraineeToJSON(requestParameters['assignTrainee']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async traineeManagementAssignTrainee(requestParameters: TraineeManagementAssignTraineeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.traineeManagementAssignTraineeRaw(requestParameters, initOverrides);
    }

    /**
     */
    async traineeManagementListTraineesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Trainee>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/trainee-management`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TraineeFromJSON));
    }

    /**
     */
    async traineeManagementListTrainees(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Trainee>> {
        const response = await this.traineeManagementListTraineesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async traineeManagementListTraineesForTrainerIdRaw(requestParameters: TraineeManagementListTraineesForTrainerIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Trainee>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling traineeManagementListTraineesForTrainerId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/trainee-management/byTrainerId/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TraineeFromJSON));
    }

    /**
     */
    async traineeManagementListTraineesForTrainerId(requestParameters: TraineeManagementListTraineesForTrainerIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Trainee>> {
        const response = await this.traineeManagementListTraineesForTrainerIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async traineeManagementUnAssignTraineeRaw(requestParameters: TraineeManagementUnAssignTraineeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['assignTrainee'] == null) {
            throw new runtime.RequiredError(
                'assignTrainee',
                'Required parameter "assignTrainee" was null or undefined when calling traineeManagementUnAssignTrainee().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/trainee-management`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: AssignTraineeToJSON(requestParameters['assignTrainee']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async traineeManagementUnAssignTrainee(requestParameters: TraineeManagementUnAssignTraineeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.traineeManagementUnAssignTraineeRaw(requestParameters, initOverrides);
    }

}
